var map = {
	"./Add_Dots.jpg": 919,
	"./Add_Lines.jpg": 774,
	"./Clear_Canvas.jpg": 545,
	"./Commit_Image.jpg": 722,
	"./Connect_Image_Image.jpg": 753,
	"./Erase_Lines-jpg.jpg": 295,
	"./Folder_Uploaded_Image.jpg": 454,
	"./Image_Actual_Image_On_Screen.jpg": 90,
	"./Images_Connected_Image.jpg": 171,
	"./Instructions_1 screenshot.png": 522,
	"./Move_Image.jpg": 706,
	"./MyQueriesButton.jpg": 461,
	"./MyQueriesPage.jpg": 980,
	"./Name_Folder_Image.jpg": 121,
	"./QueryCreator.jpg": 771,
	"./ScreenshotForQueries.jpg": 772,
	"./Select_Images_Directory_Image.jpg": 452,
	"./SmartDraw.jpg": 286,
	"./Upload_Folder_Directory_Open_Image.jpg": 444,
	"./Upload_Folder_Image.jpg": 539,
	"./Upload_Folder_In_Directory_Image.jpg": 333,
	"./Zoom.jpg": 898,
	"./delete_dots.jpg": 615
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64;